'use client'

import { Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from "@heroui/react";
import { useEffect } from "react";

export default function ModalError({ errorMessage, setErrorMessage }: { errorMessage: any, setErrorMessage?: any }) {
    const { isOpen, onOpen, onOpenChange } = useDisclosure()

    useEffect(() => {
        const fetchGet = async () => {
            console.log({ errorMessage })
            if (errorMessage != "")
                onOpen();
        }

        fetchGet()
    }, [errorMessage])

    return (
        <>
            <Modal size="lg"
                isOpen={isOpen} 
                placement={'center'}
                onOpenChange={onOpenChange} 
                className="block-active !bg-[var(--color-main2)]"
                onClose={() => {if(setErrorMessage) setErrorMessage('')}}
            >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1 headerh2 text-center">{errorMessage}</ModalHeader>
                            <ModalBody>
                                
                            </ModalBody>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    )
}
